export const createContainer = (classList: string, parent?: string): HTMLElement => {
  const container: HTMLElement = document.createElement('div')
  container.classList.add(classList)
  if (parent) {
    const parentDiv = document.querySelector(`#${parent}`)
    parentDiv && parentDiv.appendChild(container)
  } else document.body.appendChild(container)
  return container
}
